import { Page, Text } from "@shopify/polaris";
import { useRouter } from "next/router";
export default function AccessDenied(props) {
    const router = useRouter();
    return (
        <Page>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "15%" }}>
                <div style={{ width: "100px", height: "100px", padding: "10px" }}>
                    <img src="https://loop-subscription-assets.s3.amazonaws.com/permission_denied.svg" />
                </div>
            </div>
            <h1 style={{ textAlign: "center", fontWeight: "bold", fontSize: "25px", marginBottom: "20px", marginTop: "20px" }}> Access denied </h1>

            <Text variant="headingMd" fontWeight="regular" as="p" alignment="center" >
                Your account <span style={{ fontWeight: "bold" }}>{props.userEmail}</span> doesn’t have permission to view this page.
                Try using a different account or ask your store administrator to provide
                you the necessary permission.{" "}
                <br />
            </Text>
        </Page>
    );
}
